import { Button, IconButton } from '@getsynapse/design-system';
import { useState } from 'react';
import ShareIcon from 'assets/icons/share.svg';
import intl from 'react-intl-universal';
import ManageAccessModal from 'Organisms/ManageAccessModal/ManageAccessModal';
import AgentDashboardSharesModal from 'Organisms/AgentDashboardSharesModal/AgentDashboardSharesModal';

export const DashboardSharedOverflowMenu = ({
  isIconButton = false,
  isAgentGenerated = false,
  dashboardId,
}: {
  isIconButton?: boolean;
  isAgentGenerated?: boolean;
  dashboardId: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isIconButton ? (
        <IconButton
          name='share-social-outline'
          className='text-base text-neutral-dark p-2'
          onClick={() => setIsModalOpen(true)}
        />
      ) : (
        <Button
          size='small'
          variant='tertiary'
          iconSrc={ShareIcon}
          iconPosition='left'
          data-testid='table-header__share-button'
          onClick={() => setIsModalOpen(true)}
        >
          {intl.get('TABLE_HEADER_ACTIONS.SHARE')}
        </Button>
      )}

      {isAgentGenerated ? (
        <AgentDashboardSharesModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          dashboardId={dashboardId}
        />
      ) : (
        <ManageAccessModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          dashboardId={dashboardId}
        />
      )}
    </>
  );
};
